import { getBrowserBridgeAPI, type ClientId } from '@atlassian/rovo-content-bridge-api';
import {
	InlineInputBoxSendMessageCommand,
	ROVO_CHAT_CLIENT_ID,
} from '@atlassian/rovo-content-bridge-api-commands';
import { type RovoContentBridgeSetupHandler } from '@atlassian/rovo-content-bridge-api/client';
import { useCallback } from 'react';
import { BoeSubmitPrompt } from './commands/boe-submit-prompt.ts';

export const useBoeSubmitPromptHandler = (): RovoContentBridgeSetupHandler => {
	const bindHandlersCallback: RovoContentBridgeSetupHandler = useCallback((on) => {
		on(BoeSubmitPrompt, (data) => {
			const bridgeAPI = getBrowserBridgeAPI();
			const CONFLUENCE_AFM_CLIENT_ID = 'confluence-afm' as ClientId;

			bridgeAPI.send(InlineInputBoxSendMessageCommand, {
				senderId: CONFLUENCE_AFM_CLIENT_ID,
				receiverId: ROVO_CHAT_CLIENT_ID,
				prompt: data.prompt,
				source: 'CONFLUENCE_CREATE_WITH_ROVO',
				productKey: 'confluence',
				deepResearchEnabled: false,
				webSearchEnabled: false,
				contentId: data.contentId || '',
				openChat: false,
				addCurrentPageAsContextUserPreference: true,
				creationContextParams: {
					shouldUseExistingContent: true,
				},
			});
		});
	}, []);

	return bindHandlersCallback;
};
